<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef"></sideBar>
				<div class="v-content-wrapper">
					<div class="v-content-container">
						<!--						<div class="store-step-wrapper">
							<div class="steps-block">
								<el-steps :active="2" align-center>
								  <el-step title="店铺设置"></el-step>
								  <el-step title="支付设置"></el-step>
								  <el-step title="店铺验证"></el-step>
								  <el-step title="商品管理"></el-step>
								</el-steps>
							</div>
							<div class="step-explain-container">
								<div class="step-explain-title">Welocome To Zendrop</div>
								<div class="step-explain-contents">Please update your store information to ensure that customers can browse it normally</div>
								<div class="step-btns">Go To Setting</div>
							</div>
						</div>-->
						<div class="data-column-wrapper">
							<div class="d-header" style="display: flex;align-items: center;">{{$t('menu.dashboard')}}
								<span @click="openPage('store-certification')" class="store-message"
									v-if="storeSta == '4' || storeSta == '0'">{{storeMessage}}</span>
								<span class="store-message" v-if="storeSta == '3' ">{{storeMessage}}</span>
                <span class="store-message" v-if="storeSta == '5' ">{{storeMessage}}</span>
							</div>
							<div class="data-grid-container">
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/product.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('menu.product')}}</div>
											</div>
											<div class="d-num">{{ storeInfo.totalProduct }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/order.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.totalorders')}}</div>
											</div>
											<div class="d-num">{{ statisticsOrder.totalOrder }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/sale.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.totalsales')}}</div>
											</div>
											<div class="d-num">{{ statisticsOrder.totalSales }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/lr.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.totalprofit')}}</div>
											</div>
											<div class="d-num">{{ statisticsOrder.totalProfit }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
							</div>
							<div class="data-grid-container" style="margin-top: 20px;">
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/product.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.creditscore')}}</div>
											</div>
											<div class="d-num">{{ storeInfo.creditScore }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/order.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.fans')}}</div>
											</div>
											<div class="d-num">{{ statisticsOrder.totalFans }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/sale.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.dailytraffic')}}</div>
											</div>
											<div class="d-num">{{ traffic.dayTraffic }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
								<div class="d-grid-item">
									<div class="channel-item">
										<div class="d-grid-infos">
											<div class="d-g-header">
												<div class="d-img-blcok">
													<img src="../../assets/images/home/lr.png" class="d-icon" />
												</div>
												<div class="d-txt">{{$t('common.seventraffic')}}</div>
											</div>
											<div class="d-num">{{ traffic.sevenTraffic }}</div>
										</div>
										<img src="../../assets/images/atr.png" class="d-b-icon" />
									</div>
								</div>
							</div>
						</div>
						<div class="top-data-container">
							<div class="dataCenter-container">
								<div class="data-header">
									<div class="d-header-txt">{{$t('common.orderdata')}}</div>
								</div>
								<div class="homeData-wrap">
									<div class="home-data-box">
										<div class="px-h-block">
											<div class="d-txt">{{$t('common.pendingpayment')}}</div>
											<div class="d-num">{{ dayStatistics.totalOrder }} </div>
										</div>
									</div>
									<div class="home-data-box">
										<div class="px-h-block">
											<div class="d-txt">{{$t('common.processedorders')}}</div>
											<div class="d-num">{{ dayStatistics.totalCancelled }}</div>
										</div>
									</div>
									<div class="home-data-box">
										<div class="px-h-block">
											<div class="d-txt">{{$t('common.outfordelivery')}}</div>
											<div class="d-num"> {{ dayStatistics.outDelivery }}</div>
										</div>
									</div>
									<div class="home-data-box">
										<div class="px-h-block">
											<div class="d-txt">{{$t('common.delivered')}}</div>
											<div class="d-num"> {{ dayStatistics.delivered }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="data-column-wrapper store-wrapper" style="margin-top: 20px;">
							<div class="d-header">{{$t('common.merchantinformation')}}</div>
							<div class="business-data-container">
								<div class="business-data-item">
									<div class="b-title">{{$t('menu.shoplevle')}}
										<img v-if="storeSta != 1" src="../../assets/images/uncertification.png"
											class="certification-icon" />
										<img v-else src="../../assets/images/certification.png"
											class="certification-icon" />
									</div>
									<div class="store-infos">
										<div class="store-txt">{{ storeInfo.levelName }}</div>
										<div class="progress">
											<el-progress :percentage="nextLevel.nextRate*100"></el-progress>
										</div>
										<div class="disk-tips">{{ nextLevel.totalMoney }}/{{ nextLevel.money }}</div>
									</div>
									<img src="../../assets/images/home/diskbg.png" class="d-bg" />
								</div>
								<div class="business-data-item" @click="openPage('store')">
									<div>
										<div class="r-title">{{$t('common.paymentsetting')}}</div>
										<div class="go-btns">
											{{$t('common.configurenow')}}
											<span class="g-icon">▶</span>
										</div>
									</div>
									<img class="d-bg" src="../../assets/images/home/diskbg.png" />
								</div>
								<div class="business-data-item" @click="openPage('setting')">
									<div>
										<div class="r-title">{{$t('menu.shopsetting')}}</div>
										<div class="go-btns">
											{{$t('common.gotosettings')}}
											<span class="g-icon">▶</span>
										</div>
									</div>
									<img class="d-bg" src="../../assets/images/home/diskbg.png" />
								</div>
								<div class="business-data-item" @click="openPage('addProduct')">
									<div>
										<div class="r-title">{{$t('common.addnewproduct')}}</div>
										<div class="go-btns">
											{{$t('common.goimmediately')}}
											<span class="g-icon">▶</span>
										</div>
									</div>
									<img class="d-bg" src="../../assets/images/home/diskbg.png" />
								</div>
							</div>
						</div>
						<!-- <div class="data-column-wrapper-center">

							<div class="data-grid-container-center">
								<div class="d-grid-item">
									<div class="d-grid-item-content">
										<div class="d-txt">orders</div>
										<div class="d-order-container">
											<div class="d-order-icon-container">
												<img src="../../assets/images/index/order.png" class="d-order-icon" />
											</div>
											<div class="d-order-txt-container">
												<div class="d-order-txt-title">New orders</div>
												<div class="d-order-txt">{{ dayStatistics.totalOrder }}</div>
											</div>
										</div>
										<div class="d-order-container">
											<div class="d-order-icon-container">
												<img src="../../assets/images/index/cancelled.png"
													class="d-order-icon" />
											</div>
											<div class="d-order-txt-container">
												<div class="d-order-txt-title">Cancelled</div>
												<div class="d-order-txt">{{ dayStatistics.totalCancelled }}</div>
											</div>
										</div>
										<div class="d-order-container">
											<div class="d-order-icon-container">
												<img src="../../assets/images/index/delivery.png"
													class="d-order-icon" />
											</div>
											<div class="d-order-txt-container">
												<div class="d-order-txt-title">Out for Delivery</div>
												<div class="d-order-txt">{{ dayStatistics.outDelivery }}</div>
											</div>
										</div>
										<div class="d-order-container">
											<div class="d-order-icon-container">
												<img src="../../assets/images/index/delivered.png"
													class="d-order-icon" />
											</div>
											<div class="d-order-txt-container">
												<div class="d-order-txt-title">Delivered</div>
												<div class="d-order-txt">{{ dayStatistics.delivered }}</div>
											</div>
										</div>
									</div>
								</div>

								<div class="d-grid-item" style="border:0">
									<div class="d-order-txt-shop">
										<div class="d-order-txt-shop-title ">Shop Level: {{ storeInfo.levelName }}</div>
										<div class="d-order-container-shop-level"><img :src="storeInfo.levelImg "
												class="d-order-shop-icon" /> </div>
									</div>
									<div class="d-order-txt-shop" style="margin-top: 20px;">
										<div class="d-order-txt-shop-title">Next level: {{ nextLevel.levelName }}</div>
										<el-progress :text-inside="true" :stroke-width="24"
											:percentage="nextLevel.nextRate*100" class="data-column-progress-center"
											status="success"></el-progress>
										<div class="d-order-txt-shop-num">
											{{ nextLevel.totalMoney }}/{{ nextLevel.money }}</div>
									</div>
								</div>


								<div class="d-grid-item" style="border:0">
									<div class="d-order-pay" @click="openPage('store')" style="cursor: pointer">
										<div class="d-order-pay-title">Payment Setting</div>
										<div class="d-order-pay-img"><img src="../../assets/images/index/pay_seting.png"
												alt="" class="d-order-pay-icon" /> </div>
										<div class="d-order-pay-button">Configure now</div>
									</div>
									<div class="d-order-pay-v">
										<div class="d-order-pay-v-img"><img src="../../assets/images/index/verified.png"
												alt="" /> </div>
									</div>
								</div>


								<div class="d-grid-item" style="border:0">
									<div class="d-order-pay" style="cursor: pointer" @click="openPage('setting')">
										<div class="d-order-pay-title">Shop Setting</div>
										<div class="d-order-pay-img"><img
												src="../../assets/images/index/shop_seting.png" alt=""
												class="d-order-pay-icon" /> </div>
										<div class="d-order-pay-button">Go to settings</div>
									</div>
									<div class="d-order-product" style="cursor: pointer">
										<div class="d-order-product-title">Add new product</div>
										<div class="d-order-product-img" @click="openPage('addProduct')"><img
												src="../../assets/images/index/add.png" alt=""
												class="d-order-pay-icon" /> </div>
									</div>
								</div>
							</div>
						</div> -->
						<div class="data-column-wrapper-center-swiper" style="margin-top: 20px;">
							<div style="flex: 1;">
								<div class="swiper-container swiper-container-top">
									<swiper :options="swiperOptions" ref="mySwiper">
										<swiper-slide v-for="(item, index) in storeProductList" :key="index">
											<div class="product-item">
												<img :src="item.icon" class="slide-image" alt="Product Image" />
												<div class="price">${{ item.discountPrice }}</div>
												<div class="rate">
													<el-rate v-model="item.rating" disabled show-score
														text-color="#ff9900" size="small"></el-rate>
												</div>
												<div class="title">{{ item.productName }}</div>
											</div>
										</swiper-slide>
										<div class="swiper-button-prev" slot="button-prev"></div>
										<div class="swiper-button-next" slot="button-next"></div>
									</swiper>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="occupy-space"></div>
		</div>
		<tabBar ref="tabBarRef" current="0"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		storeStatistics,
		getStoreInfo,
		dayStatistics,
		getNextLevel,
		traffic,
		queryIdCardSta
	} from "@/api/home";
	import {
		selectStoreProduct
	} from "@/api/storeProduct";

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				traffic: {
					dayTraffic: 0,
					sevenTraffic: 0,
				},
				value: 3.5,
				storeProductList: [],
				statisticsOrder: {
					totalOrder: 0,
					totalSales: 0,
					totalProfit: 0,
					totalFans: 0,
				},
				storeInfo: {
					totalProduct: 0,
					creditScore: 0,
					levelNo: null,
					levelName: null,
				},
				nextLevel: {
					levelNo: null,
					levelName: null,
					money: 0,
				},
				dayStatistics: {
					totalOrder: 0,
					totalCancelled: 0,
					outDelivery: 0,
					delivered: 0,
				},
				// Swiper 配置项
				swiperOptions: {
					slidesPerView: 1,
					spaceBetween: 30,
					loop: true,
					breakpoints: {
						// 屏幕宽度 >= 640px 时显示 2 列
						640: {
							slidesPerView: 1,
							spaceBetween: 20
						},
						// 屏幕宽度 >= 768px 时显示 3 列
						768: {
							slidesPerView: 3,
							spaceBetween: 30
						},
						// 屏幕宽度 >= 1024px 时显示 6 列（适配 PC 大屏）
						1024: {
							slidesPerView: 6,
							spaceBetween: 30
						}
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					autoplay: {
						delay: 3000
					}
				},
				products: [{
						image: require('@/assets/images/products/band-aid.jpg'),
						name: 'Band-Aid Brand Flexible Fabric Adhesive Bandages',
						price: '3.02',
						rating: 5
					},
					{
						image: require('@/assets/images/products/funight-kn95.jpg'),
						name: 'Funight KN95 Face Masks 50 Pack 5-Ply Breathable Filter',
						price: '12.79',
						rating: 5
					},
					{
						image: require('@/assets/images/products/band-aid.jpg'),
						name: 'PURE GEM [Pack of 150] Single Use Disposable Blue Face Mask',
						price: '7.99',
						rating: 4.5
					},
					{
						image: require('@/assets/images/products/band-aid.jpg'),
						name: 'NNPCBT 100PCS 3 Ply Black Disposable Face Mask Filter',
						price: '7.98',
						rating: 4.5
					},
					{
						image: require('@/assets/images/products/funight-kn95.jpg'),
						name: 'LEMENT 50pcs KN95 Face Mask Black 5 Layer Cup Dust Safety',
						price: '7.99',
						rating: 4.5
					},
					{
						image: require('@/assets/images/products/funight-kn95.jpg'),
						name: '100 PCS Disposable Face Masks, Black Disposable Masks, 3 Ply',
						price: '7.98',
						rating: 4.5
					}
				],
				tabList: [{
						title: this.$t('home.today')
					},
					{
						title: this.$t('home.yesterday')
					},
					{
						title: this.$t('home.last7days')
					},
					{
						title: this.$t('home.last30days')
					},
				],
				tabIndex: 0,
				storeSta: 0,
				storeMessage: ''
			}
		},
		mounted() {
			this.getStatistics()
			this.getStoreInfo()
			this.getdayStatistics()
			this.getStoreProduct()
			this.getTraffic()
			this.getStoreSta()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getTraffic() {
				traffic().then(res => {
					this.traffic = res.data;
				})
			},
			getStoreProduct() {
				selectStoreProduct(this.queryStoreProduct).then(res => {
					if (res.code == 200) {
						this.storeProductList = res.rows;
						this.total = res.total;
					} else {
						return false;
					}
				})
			},
			getNextLevel(sort) {
				let params = {
					sort: sort
				}
				getNextLevel(params).then(res => {
					this.nextLevel = res.data;
				})
			},
			getdayStatistics() {
				dayStatistics().then(res => {
					this.dayStatistics = res.data;
				})
			},
			getStatistics() {
				storeStatistics().then(res => {
					this.statisticsOrder = res.data;
				})
			},
			getStoreInfo() {
				getStoreInfo().then(res => {
					this.storeInfo = res.data;
					this.getNextLevel(res.data.sort)
				})
			},
			changeTab(index) {
				this.tabIndex = index
			},
			getStoreSta() {
				var that = this
				queryIdCardSta().then(res => {
					that.storeSta = res.data.status
					that.storeMessage = res.data.remark
					if (res.data.status == '0') {
						that.openPage('store-certification')
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/index.css");
</style>
<style scoped>
	/* 确保父容器作为定位基准并充满可用空间 */
	.data-column-wrapper-center-swiper {
		position: relative;
		/* 作为 swiper-container 的定位上下文 */
		height: 330px;
		/* 或根据实际需求设置具体高度，如 100vh 占满视口 */
		overflow: hidden;
		/* 防止内容超出父容器 */
		margin: 0 15px 20px 0;
		overflow: hidden;
		background-color: #fff;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;


	}

	@media (max-width: 767px) {
		.data-column-wrapper-center-swiper {
			margin-left: 20px;
		}
	}

	/* 让 swiper-container 完全填充父容器 */
	.swiper-container {
		position: absolute;
		top: 5px;
		left: 5px;
		width: 100%;
		height: 300px;
		box-sizing: border-box;
		/* 确保内边距/边框不导致尺寸超出 */
		margin: 0 auto;
	}

	.swiper-container-top {
		height: 320px;
	}

	.swiper-container .title {
		height: 40px;
		line-height: 20px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	/* H5 适配：移除默认 body 边距，确保全屏显示 */
	body {
		margin: 0;
		padding: 0;
		overflow-x: hidden;
		/* 防止横向滚动 */
	}

	.slide-image {
		width: 100%;
		max-width: 240px;
		height: 150px;
		object-fit: cover;
		border-radius: 8px;
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.swiper-slide {
		text-align: center;

		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 10px;
		border-radius: 8px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
		width: 100%;
		max-width: 240px;
		margin: 10px 0 0;
		height: 280px;
	}

	.swiper-button-next,
	.swiper-button-prev {
		width: 35px;
		/* 箭头容器宽度 */
		height: 35px;
		/* 箭头容器高度 */
		background-color: #fff;
		/* 背景色 */
		border-radius: 50%;
		/* 圆形按钮 */
		color: white;
		/* 箭头颜色 */
		font-size: 20px;
		/* 箭头大小 */
		border: 1px solid rgba(0, 0, 0, 0.2);
	}

	/* 单独设置下一个箭头 */
	.swiper-button-next::after {
		content: '>';
		/* 自定义图标 */
		font-family: sans-serif;
		color: rgba(0, 0, 0, 0.5);
		/* 背景色 */
		;
		line-height: 26px;
		font-size: 14px;
		font-weight: bold;
	}

	/* 单独设置上一个箭头 */
	.swiper-button-prev::after {
		content: '<';
		/* 自定义图标 */
		font-family: sans-serif;
		color: rgba(0, 0, 0, 0.5);
		/* 背景色 */
		;
		line-height: 26px;
		font-size: 14px;
		font-weight: bold;
	}

	.certification-icon {
		width: 15px;
		height: 15px;
		margin-left: 5px;
	}

	.store-message {
		font-size: 12px;
		color: red;
		cursor: pointer;
		margin-left: 8px;
	}

	/* 悬停效果 */
	/*.swiper-button-next:hover,
.swiper-button-prev:hover {
  background-color: rgba(0,0,0,0.8);
}*/
</style>
